export enum PHASES {
  PREMINT = 'premint',
  WAITING = 'waiting',
  MINT = 'mint',
  POST = 'post',
  AIRDROP = 'airdrop',
};
